<template>
  <v-container fluid>
    <h2 class="mb-3">Daily Attendance</h2>
    <v-card>
      <v-tabs background-color="white" color="primary" left @change="changeActiveTab($event)">
        <v-tab>Schedule Regular</v-tab>
        <v-tab>Schedule Shift</v-tab>

        
        <v-tab-item>
          <v-container fluid>
            <Regular v-if="tabActive == 0"></Regular>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <Shift v-if="tabActive == 1"></Shift>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import Regular from "./components/Regular";
import Shift from "./components/Shift";
export default {
  name: "schedule",
  data() {
    return {
      tabActive: 0
    };
  },
  methods: {
    changeActiveTab(e) {
      this.tabActive = e
    }
  },
  created() {},
  components: {
    Regular,
    Shift,
  }
};
</script>
